import React from "react";
import { useParams } from "react-router-dom";
import { TwitchEmbed, Header } from "../../components";
import "./StreamPage.css"

export function StreamPage() {
  const params = useParams();

  let channel = "coolk619";
  switch (params.id) {
    case "1":
      channel = "akysbesportscanada";
      break;
    default:
      channel = "monstercat";
      break;
  }

  const props = {
    targetID: "twitch-embed",
    width: "940",
    height: "480",
    channel: channel,
  };
  
  return (
    <div className="container">
      <Header title={`Stream ${params.id}`} />
      <div className="twitchContainer">
        <TwitchEmbed {...props} />
      </div>
    </div>
  );
}
